<template>
  <div>
    <v-card flat rounded="lg" class="mt-4">
      <v-card-title class="font-weight-bold">
        Cadastre uma senha de {{ parametros.num_dig_senha }} dígitos para ser
        utilizada nas compras a prazo
      </v-card-title>
      <v-card-text>
        <v-alert
          type="success"
          text
          v-if="parametros.possui_senha_compra_prazo"
          rounded="lg"
        >
          <p class="mb-1">Você já possui uma senha configurada!</p>
          <p class="mb-0">
            <b>Lembre-se de compartilhar sua senha com seus autorizados!</b>
          </p>
        </v-alert>
        <v-alert type="warning" text v-else rounded="lg">
          <p class="font-weight-bold">
            Você ainda não possui uma senha para compras a prazo.
          </p>
          <p class="mb-0">Utilize o botão abaixo para configurar!</p>
        </v-alert>
        <manut-senha-compras-prazo />
      </v-card-text>
    </v-card>
    <v-card flat rounded="lg" class="mt-4 font-weight-bold">
      <v-card-title class="font-weight-bold"
        >Pessoas autorizadas a comprar a prazo</v-card-title
      >
      <v-card-text>
        <autorizados-compra-prazo />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AutorizadosCompraPrazo from "./AutorizadosCompraPrazo.vue";
import ManutSenhaComprasPrazo from "./ManutSenhaComprasPrazo.vue";
export default {
  components: { ManutSenhaComprasPrazo, AutorizadosCompraPrazo },
  computed: {
    ...mapState("configComprasPrazo", ["parametros"]),
  },
  data: () => ({}),
};
</script>

<style>
</style>